var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalHighRiskLocalRoles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#751F4A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.547 13.613a.208.208 0 0 0-.196-.28H8.75a.417.417 0 0 1-.417-.416V12.5c0-.23.187-.417.417-.417h2.762a.21.21 0 0 0 .167-.078l3.278-4.096A.204.204 0 0 0 15 7.78V1.667C15 .747 14.254 0 13.333 0H1.667C.747 0 0 .746 0 1.667v8.75c0 .92.746 1.666 1.667 1.666H6.25c.23 0 .417.187.417.417v.417c0 .23-.187.416-.417.416H4.167a.833.833 0 0 0 0 1.667h6.117a.209.209 0 0 0 .167-.083.208.208 0 0 0 .038-.179 1.963 1.963 0 0 1 .058-1.125zm-8.464-4.03a.417.417 0 0 1-.416-.416V2.083c0-.23.186-.416.416-.416h10.834c.23 0 .416.186.416.416v7.084c0 .23-.186.416-.416.416H2.083zM19.827 13.703a.73.73 0 0 0-.556-1.203h-1.563a.208.208 0 0 1-.208-.208V7.917a.417.417 0 0 0-.742-.261l-4.916 6.141A.73.73 0 0 0 12.396 15h1.562c.115 0 .209.093.209.208v4.375a.417.417 0 0 0 .741.26l4.919-6.14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalHighRiskLocalRoles);
export default __webpack_public_path__ + "static/media/total-high-risk-local-roles.a8ac4531db0ab6a62bbe9543d47bbc35.svg";
export { ForwardRef as ReactComponent };